import React, { forwardRef, useId, useRef, useState } from 'react';
import { parseMathExpression } from '../lib/mathExpression.mjs';
import MathText from './MathText';

const templates = [
  ['a/b', 'Fraction', '()/()', 1], ['x²', 'Carré', '()^2', 1], ['xⁿ', 'Puissance', '()^()', 1],
  ['√', 'Racine carrée', 'sqrt()', 5], ['|x|', 'Valeur absolue', 'abs()', 4],
  ['sin', 'Sinus', 'sin()', 4], ['cos', 'Cosinus', 'cos()', 4], ['ln', 'Logarithme naturel', 'ln()', 3], ['π', 'Pi', 'pi', 2],
];
const MathAnswerInput = forwardRef(function MathAnswerInput({ value, onChange, disabled, maxLength = 128, numeric = true, ...props }, forwardedRef) {
  const localRef = useRef(null), helpId = useId();
  const [open, setOpen] = useState(false);
  let preview = '', error = '';
  if (open && value.trim()) {
    try { preview = parseMathExpression(value, { symbolic: !numeric }).tex; }
    catch (e) { error = e.message; }
  }
  function insert(template, cursor) {
    const input = localRef.current, start = input.selectionStart ?? value.length, end = input.selectionEnd ?? start;
    const next = value.slice(0, start) + template + value.slice(end);
    if (next.length > maxLength) return;
    onChange({ target: { value: next } });
    requestAnimationFrame(() => { input.focus(); input.setSelectionRange(start + cursor, start + cursor); });
  }
  return <div className="math-answer">
    <input {...props} ref={element => { localRef.current = element; if (typeof forwardedRef === 'function') forwardedRef(element); else if (forwardedRef) forwardedRef.current = element; }} type="text" inputMode={open || !numeric ? 'text' : 'decimal'} value={value} onChange={onChange} maxLength={maxLength} disabled={disabled} />
    <button type="button" className="math-help-toggle" aria-expanded={open} aria-controls={helpId} disabled={disabled} onClick={() => setOpen(!open)}>ƒx {open ? 'Fermer l’aide' : 'Aide maths'}</button>
    {open && <div id={helpId} className="math-answer-help">
      <div className="math-keyboard" aria-label="Insérer une expression">{templates.map(([label, name, template, cursor]) => <button key={name} type="button" title={name} aria-label={name} disabled={disabled} onClick={() => insert(template, cursor)}>{label}</button>)}</div>
      <p>{numeric ? 'Exemples : 1/2, 2^3, sqrt(9). Les fonctions trigonométriques utilisent des radians.' : 'Écris une fonction avec x, par exemple x^2 ou sin(x). Utilise * pour multiplier.'}</p>
      {preview && <div className="math-answer-preview" aria-label="Aperçu de la réponse"><MathText>{`\\(${preview}\\)`}</MathText></div>}
      {error && <p role="status">{error}</p>}
    </div>}
  </div>;
});
export default MathAnswerInput;
